export const TypesLogin = {
	LOGIN: "LOGIN",
	LOGOUT: "LOGOUT",
	ATUALIZARTOKEN: "ATUALIZARTOKEN",
	LOGINTERMINAL: "LOGINTERMINAL",
	SKILLS: "SKILLS"
};

const INITIAL = {
	Login: "",
	Token: "",
	DataExpiracao: "",
	Terminal: 0,
	Skills: []
};

export default function LoginReducer(state = INITIAL, action) {
	//console.log(state);
	//console.log("Payload agora: " + JSON.stringify(action.payload));

	switch (action.type) {
		case TypesLogin.LOGIN:
			return {
				...state,
				Login: action.payload.Login,
				Token: action.payload.Token,
				Terminal: 0,
				DataExpiracao: action.payload.DataValidade,
			};
		case TypesLogin.LOGOUT:
			return {
				...state,
				Login: "",
				Token: "",
				DataExpiracao: "",
				Terminal: 0,
			};
		case TypesLogin.ATUALIZARTOKEN:
			return { ...state, Token: action.payload.token };
		case TypesLogin.LOGINTERMINAL:
			return {
				...state,
				Terminal: action.payload.terminal,
			};
		case TypesLogin.SKILLS:
			return { ...state, Skills: action.payload.skills }
		default:
			return state;
	}
}

export const LoginActions = {
	Logar,
	Logout,
	AtualizarToken,
	LogarTerminal,
	Skills
};

function Logar(dadosUsuario) {
	//console.log('Thiago');
	//dispatch({ type: 'mxalerta/OPEN' });
	return {
		type: TypesLogin.LOGIN,
		payload: dadosUsuario,
	};
}

function LogarTerminal(terminal) {
	//console.log('Thiago');
	//dispatch({ type: 'mxalerta/OPEN' });
	return {
		type: TypesLogin.LOGINTERMINAL,
		payload: { terminal: terminal },
	};
}

function Logout() {
	//console.log('Thiago');
	//dispatch({ type: 'mxalerta/OPEN' });
	return {
		type: TypesLogin.LOGOUT,
	};
}

function AtualizarToken(token) {
	return {
		type: TypesLogin.ATUALIZARTOKEN,
		payload: { token: token },
	};
}

function Skills(skills) {
	return {
		type: TypesLogin.SKILLS,
		payload: { skills: skills }
	}
}